module.exports = __webpack_public_path__ + "img/home_img_02.95daad8d.png";